import { Button } from '@library/components/buttons';
import type { NFLTeamInputs } from '@library/types/simulations';
import { TEAM_OVERRIDE_TYPES } from '@bo-test/mock/data/simulations';
import { TeamNumberOverride } from '@bo-components/simulations/steps/StepOneBuild/TeamInputs/inputs/TeamNumberOverride';
import { Tooltip } from '@library/components/tooltip/Tooltip';
import chevronDownIcon from '@library/assets/images/icons/chevron-down-icon.svg';
import { classNames } from '@library/utils';
import { useState } from 'react';

export const TeamInputs = ({
  teamInputs,
  onSetTeamInputs
}: {
  teamInputs: NFLTeamInputs;
  onSetTeamInputs: (
    key: keyof NFLTeamInputs,
    value: number | string | boolean
  ) => void;
}) => {
  const [showTeamOverrides, setShowTeamOverrides] = useState(true);

  const handleOnBlurForNumberInput = (field: keyof NFLTeamInputs) => {
    if (teamInputs[field] === '') {
      onSetTeamInputs(field, 0);
    }
  };

  return (
    <div
      className={classNames(
        'border-soFresh-140 inline-flex w-full flex-col items-start justify-start rounded border'
      )}
    >
      <div className="bg-soFresh-120 border-soFresh-140 font-heebo text-soClean-100 box-border flex w-full flex-row items-center justify-between rounded p-3 text-base font-medium leading-6">
        <span>Team Overrides</span>
        <div className="flex gap-4">
          <Button
            type="button"
            title="ToggleGameTeamPlayersButton"
            onClick={() => setShowTeamOverrides(!showTeamOverrides)}
          >
            <img
              alt="Chevron Down icon"
              className={classNames(showTeamOverrides ? 'rotate-180' : '')}
              src={chevronDownIcon}
            />
          </Button>
        </div>
      </div>
      {showTeamOverrides && (
        <div className="border-soFresh-140 w-full py-2">
          <div className="flex items-center justify-center gap-8">
            {TEAM_OVERRIDE_TYPES.map((teamOverride) => {
              const currentValue = teamInputs[teamOverride.value];

              return (
                <div
                  className="grid w-32 grid-flow-row grid-rows-2 items-center gap-1"
                  key={teamOverride.value}
                >
                  <Tooltip
                    text={teamOverride.description}
                    title={teamOverride.label}
                    childClassName="relative inline-block cursor-default flex justify-center"
                    className="w-60"
                  >
                    <span className="font-heebo text-center text-xs font-medium leading-3">
                      {teamOverride.label}
                    </span>
                  </Tooltip>

                  {teamOverride.type === 'number' && (
                    <TeamNumberOverride
                      currentValue={
                        currentValue !== '' ? Number(currentValue) : ''
                      }
                      min={teamOverride.minimum}
                      max={teamOverride.maximum}
                      field={teamOverride.value}
                      onBlur={handleOnBlurForNumberInput}
                      onSetTeamInputs={onSetTeamInputs}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
